import { handleActions, combineActions } from 'redux-actions';
import { LOAD_PLAYLISTS } from '../constants';

const initialState = {
  loading: false,
  error: false,
  model: null,
};

const playlistsReducer = handleActions(
  {
    [LOAD_PLAYLISTS.PENDING]: state => ({
      ...state,
      loading: true,
      error: false,
    }),
    [combineActions(
      LOAD_PLAYLISTS.CANCELLED,
      LOAD_PLAYLISTS.SUCCESS,
      LOAD_PLAYLISTS.ERROR,
    )]: state => ({
      ...state,
      loading: false,
    }),
    [LOAD_PLAYLISTS.SUCCESS]: (state, { payload }) => ({
      ...state,
      model: payload || state.model,
      error: false,
    }),
    [LOAD_PLAYLISTS.ERROR]: state => ({
      ...state,
      error: true,
    }),
  },
  initialState,
);

export default playlistsReducer;
